import __var_0__ from '@stdlib/math/base/special/floor';
import __var_1__ from '@stdlib/math/base/special/floorf';
import __var_2__ from '@stdlib/math/base/special/identity';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

/* eslint-disable stdlib/capitalized-comments */

'use strict';

// MODULES //
var floor = __var_0__;
var floorf = __var_1__;
var identity = __var_2__;


// MAIN //

var data = [
	// NOTE: the following **must** match the order in `./types.json`. The order should be according to likelihood of use (e.g., if `float64` arrays are more likely, then `float64` types/data should come before `uint8`).

	// float64
	floor,
	floor,

	// float32
	floorf,
	floor,
	floor,

	// generic
	floor,

	// int32
	identity,
	identity,
	identity,

	// int16
	identity,
	identity,
	identity,
	identity,
	identity,

	// int8
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,

	// uint32
	identity,
	identity,
	identity,

	// uint16
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,

	// uint8
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,

	// uint8c
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,
	identity,
	identity
];


// EXPORTS //
export default data;
